import { domainUrl } from '../constants';

export const API_YOUTUBE_VIDEOS = `${domainUrl}youtube-videos`;
export const API_UPDATE_YOUTUBE_VIDEO = `${domainUrl}youtube-videos/{id}`;
